import { z } from 'zod';

import { MCPSavedProfileSchema, MCPServerSchema } from './mcp-config.schema';

export const UpdateMcpConfigSchema = z
  .object({
    serversById: z.record(z.string(), MCPServerSchema),
    savedProfilesByProvider: z.record(z.string(), MCPSavedProfileSchema),
  })
  .describe(
    'Update the full MCP configuration — servers and saved profiles. Proto shape is normalised by schema transforms.',
  );

export type UpdateMcpConfigPayload = z.infer<typeof UpdateMcpConfigSchema>;
